import React from 'react';

interface ICopyPasteIconProps {
  style?: any;
}

export const CopyPasteIcon:React.FC<ICopyPasteIconProps> = (props: ICopyPasteIconProps) => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0 7.27466C0 6.26944 0.813194 5.45455 1.82012 5.45455H12.7253C13.7306 5.45455 14.5455 6.26774 14.5455 7.27466V18.1799C14.5455 19.1851 13.7323 20 12.7253 20H1.82012C0.814894 20 0 19.1868 0 18.1799V7.27466ZM1.81818 7.27273H12.7273V18.1818H1.81818V7.27273ZM8.18182 9.09091H6.36364V11.8182H3.63636V13.6364H6.36364V16.3636H8.18182V13.6364H10.9091V11.8182H8.18182V9.09091ZM18.1818 14.5455C19.186 14.5455 20 13.7294 20 12.7273V10.9091H18.1818V12.7273H16.3636V14.5455H18.1818ZM20 1.81818C20 0.814028 19.1839 0 18.1818 0H16.3636V1.81818H18.1818V3.63636H20V1.81818ZM7.27273 0C6.26857 0 5.45455 0.816071 5.45455 1.81818V3.63636H7.27273V1.81818H9.09091V0H7.27273ZM10.9091 0H14.5455V1.81818H10.9091V0ZM18.1818 5.45455H20V9.09091H18.1818V5.45455Z" fill="#CCCCCC"/>
</svg>
 )
}